import React from 'react';
import ServiceBox from './ServiceBox/ServiceBox';

const Services = () => {
    return (
        <section className="services">
            <div className="container">
                <div className="services__title-box">
                    <h2 className="services__title">Usługi</h2>
                    <div className="services__title-hr"></div>
                </div>
                <ul className="services__grid">
                    <ServiceBox treatment="Rehabilitacja ogólnoustrojowa" />
                    <ServiceBox treatment="Masaż sportowy" />
                    <ServiceBox treatment="Kinesjotaping" />
                    <ServiceBox treatment="Rehabilitacja pourazowa" />
                    <ServiceBox treatment="Terapia manualna" />
                    <ServiceBox treatment="Trening medyczny" />
                    <ServiceBox treatment="Masaż klasyczny" />
                    <ServiceBox treatment="Suche igłowanie" />
                    <ServiceBox treatment="Korekcja wad postawy" />
                </ul>
            </div>
        </section>
    );
}

export default Services;